import {HeroTicketIcon} from 'components/Icon'
import React from 'react'
import {TicketAvatarProps} from './types'
import {isPropsObjectEqual} from 'utils/props'
import {styled} from 'stitches/config'
import {styledTicketAvatar} from './styles/TicketAvatarView'

const StyledTicketAvatar = styled('div', styledTicketAvatar)

const TicketAvatarView = (props: TicketAvatarProps): React.ReactElement => {
    const {
        name,
        size,
    } = props

    return (
        <StyledTicketAvatar size={size} title={name}>
            <HeroTicketIcon size={16} strokeWidth={3} />
        </StyledTicketAvatar>
    )
}

TicketAvatarView.defaultProps = {
    name: undefined,
    size: undefined,
}

export default React.memo(TicketAvatarView, isPropsObjectEqual)
